/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export default {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
    'Funeral home': {
        message: 'If you need special assistance regarding you funeral order, please contact one of our Special Sympathy Advisors at (866)-538-2259',
        formFields: {
            firstName: 'Deceased First Name',
            lastName: 'Deceased Last Name',
            locationType: 'Location Type',
            organizationName: 'Funeral Home Name',
            funeralServiceTime: 'Start Time of Service',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: '"If there\'s a delivery issue, ie. the service started earlier or later , we\'ll call them to make sure we can deliver the arrangement.',
    },
    Hospital: {
        message: 'Patients in emergency rooms or ICU/CCU units may not be able to receive deliveries.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Hospital Name',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the patient was moved to different unit, we\'ll call them to make sure we can deliver their gift',
    },
    School: {
        message: 'Due to many school\'s security regulations, delivery to schools may not be guaranteed.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'School Name',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at school, we\'ll call them to make sure we can deliver their gift',
    },
    Church: {
        message: 'If you need special assistance regarding a memorial service, please contact one of our Special Sympathy Advisors at (866)-538-2259.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Church Name',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Apartment: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'APT/SUITE/ROOM',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
};
